// Начальные настройки карты
export const MAP_INIT_SETTINGS = {
  mapZoomCluster: 18, // Размер кластера для зума
  disableClustering: true // Отключать ли кластеризацию
};
